export const getFillTeeth = (height: number, size: number) => {
  const count = Math.max(1, Math.round(height / ((size - 1) * Math.SQRT2)));
  return { count, size: height / count / Math.SQRT2 + 1 };
};
